module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Добави",
      "to": "/moderate/section/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block row"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover table-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(section) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('span', {
      staticClass: "cat-badge",
      style: ('background-color:' + (section.color || 'black'))
    }), _vm._v(" "), (section.paid) ? _c('i', {
      staticClass: "fa fa-lock"
    }) : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/moderate/section/' + section.id + '/edit'
      }
    }, [_vm._v(_vm._s(section.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(section.description))])])
  }))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Име")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Описание")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a7cbbb8!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/admin/SectionList.vue
// module id = 649
// module chunks = 1